import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { useI18n } from '../i18n';

/**
 * `/auth/callback` —— C03 §3 為 `gaming-portal-web` 註冊的唯一 redirect URI。
 * 這一頁只做一件事：把 code 換成 token，然後導到 `state.next`（已過 isSafeNextPath）。
 */
export function CallbackPage() {
  const { completeLogin } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    // StrictMode 會跑兩次 effect；PKCE 的 code 只能兌換一次。
    if (ran.current) return;
    ran.current = true;
    completeLogin()
      .then((next) => navigate(next, { replace: true }))
      .catch((e: unknown) => setError(e instanceof Error ? e.message : String(e)));
  }, [completeLogin, navigate]);

  if (error) {
    return (
      <div className="notice notice--error stack stack--tight">
        <strong>{t('auth.failed')}</strong>
        <span className="faint">{error}</span>
        <Link className="btn btn--sm" to="/">
          {t('game.back')}
        </Link>
      </div>
    );
  }

  return <p className="muted">{t('auth.processing')}</p>;
}
